import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { SqlGeneratorRoutingModule } from './sql-generator-routing.module';
import { SqlGeneratorComponent } from './sql-generator.component';
import { DatabaseSelectorComponent } from './database-selector/database-selector.component';
import { CustomerSelectorComponent } from './customer-selector/customer-selector.component';
import { ChatService } from '../shared/chatbot/services/chat.service';
import { SupersetApiModule } from '../shared/services/superset-api/superset-api.module';
import { CreateDatasetDialogComponent } from './create-dataset-dialog/create-dataset-dialog.component';
import { SharedModule } from '../shared/shared.module';
import { MarkdownModule } from 'ngx-markdown';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatChipsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatDialogModule,
    MatInputModule,
    MatProgressSpinnerModule,
    ClipboardModule,
    SharedModule,
    SqlGeneratorRoutingModule,
    MarkdownModule.forChild(),
    SupersetApiModule,
    SqlGeneratorComponent,
    DatabaseSelectorComponent,
    CustomerSelectorComponent,
    CreateDatasetDialogComponent
  ],
  exports: [SqlGeneratorComponent],
  providers: [ChatService]
})
export class SqlGeneratorModule {}
